function t(t){if(void 0!==t){if("number"==typeof t)return 100*t;if("string"==typeof t){const e=t.replace(":","/"),[r,n]=e.split("/").filter((function(t){return"/"!==t}));return(n?+n/+r*100:100*+r)||t}}}export{t as default};
